module.exports = __webpack_public_path__ + "images/boxes/replay_1-39b8e119bbe100da8c241deeb1f5fb54.webp";